// extracted by mini-css-extract-plugin
module.exports = {"customer_section":"FlowsLayoutStyle_customer_section__15ZPb","container":"FlowsLayoutStyle_container__2qexE"};